import React from 'react'
import "./TestQuestions.css"
import Dashboard from '../Dashboard/Dashboard'
import imgF from "../../images/goog.png"
import lock from "../../images/lock1.svg";

function TestQuestions() {

    return (
        <div>

            <div className='result-cont testquest'>
                <div className="container-fluid">
                    <div className="row">


                        <div className="col-12 col-sm-12 col-md-3 col-lg-3 testquo">
                            <Dashboard />
                        </div>

                        <div className="col-12 col-sm-12 col-md-9 col-lg-9 testquo-cont">
                            <div className="test-quo-sub">

                                <div className="test-quo-box1">
                                    <h5>Custom Q&A - 32 Advanced Questions</h5>

                                    <div className="test-quo-box1-sub">
                                        <h5>The Firebrand (Q V H W Z A)</h5>
                                        <p>Someone who blends quiet empathy, fierce creativity, and adrenaline-fueled independence to tackle challenges, often in solitary bursts.</p>
                                        <p>By answering these prompts, you'll uncover more about your personal style, emotional triggers, work preferences, and how you navigate both internal and external pressures. Later, you (or a coach/mentor) can interpret your responses to craft personalized feedback and advice on harnessing your Firebrand strengths.</p>

                                    </div>

                                </div>


                                <div className="test-quo-box2">



                                    <div className="test-quo-box2-heads">

                                        <a href="">Questions</a>
                                        <a href="">Responses</a>
                                        <a href="">Settings</a>

                                    </div>

                                    <div className="test-quo-box2-form">


                                        {/* <div className="test-quo-from1"></div> */}

                                        <div className="test-quo-from2">

                                            <img src={imgF} alt="" />
                                        </div>




                                        {/* <div className="arche-last-div-new arche-last-div-testquo">

                                            <span><img src={lock} alt="" /></span>

                                           
                                            <h6>Ready to unlock the full potential of your Archetype?</h6>
                                            <p>Upgrade to our premium content and transform your quiet, steady leadership into a secret
                                                superpower-fueling team synergy and delivering results that truly shine.</p>
                                            <a href="/tests">
                                                <button className="arche-btn2-new arche-btn2-testquo">Upgrade today</button>
                                            </a>


                                        </div> */}



                                    </div>



                                </div>



                            </div>


                        </div>



                    </div>
                </div>
            </div>


        </div>
    )
}

export default TestQuestions



